import { readonly, ref } from 'vue';
import axiosClient from '@/axiosClient';
import { API_ENDPOINTS } from '@/apiConfig';

export function useAttendanceCompanyBulk() {
  const attendanceRecords = ref([]);
  const loading = ref(false);
  const submitting = ref(false);
  const error = ref(null);

  const getErrorMessage = (requestError, fallback) => (
    requestError.response?.data?.error
    || requestError.message
    || fallback
  );

  const fetchAttendanceRecords = async attendanceIds => {
    loading.value = true;
    error.value = null;
    attendanceRecords.value = [];

    try {
      const response = await axiosClient.post(API_ENDPOINTS.fetchAttendanceBulk, {
        attendance_ids: attendanceIds,
      });
      if (!Array.isArray(response.data?.items)) {
        throw new Error('Invalid bulk attendance response.');
      }
      attendanceRecords.value = response.data.items;
      return true;
    } catch (requestError) {
      error.value = getErrorMessage(requestError, 'Failed to load attendance records.');
      return false;
    } finally {
      loading.value = false;
    }
  };

  const updateAttendanceCompanies = async changes => {
    submitting.value = true;
    error.value = null;

    try {
      const response = await axiosClient.post(API_ENDPOINTS.updateAttendanceCompanies, {
        changes,
      });
      return { success: true, data: response.data };
    } catch (requestError) {
      const message = getErrorMessage(requestError, 'Failed to update attendance companies.');
      error.value = message;
      return { success: false, error: message };
    } finally {
      submitting.value = false;
    }
  };

  return {
    attendanceRecords: readonly(attendanceRecords),
    loading: readonly(loading),
    submitting: readonly(submitting),
    error: readonly(error),
    fetchAttendanceRecords,
    updateAttendanceCompanies,
  };
}
